<template>
  <div class="UserPackage-detail-page w-100" :class="{ 'in-modal': inModal }">
    <b-form @submit="handleValidate">
      <basic-subheader v-if="!inModal">
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <template>
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg
                  :src="`/media/svg/icons/Neolex/Basic/${
                    isCreateForm ? 'plus' : 'save'
                  }.svg`"
                />
              </span>
              {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container
          fluid
          :class="inModal ? 'p-0' : 'UserPackage-list-page__body mb-6 mt-6'"
        >
          <b-row>
            <b-col>
              <div :class="inModal ? '' : 'card card-custom gutter-b w-100'">
                <div :class="inModal ? '' : 'card-body mt-0'">
                  <h5 v-if="!inModal" class="card-title text-success mb-6">
                    Thông tin gói dịch vụ
                  </h5>

                  <b-row>
                    <b-col md="6">
                      <basic-input
                        label="Số điện thoại"
                        placeholder="Số điện thoại"
                        name="phoneNumber"
                        :required="true"
                        data-vv-As="Số điện thoại"
                        v-validate="{ required: true, regex: /^[+0-9]{8,13}$/ }"
                        :value.sync="form.phoneNumber"
                        :state="validateState('phoneNumber')"
                        :invalidFeedback="errors.first('phoneNumber')"
                        @input="getPatientExisted"
                        type="text"
                        maxlength="13"
                      ></basic-input>

                      <!-- Chỉ hiện sau khi tra xong, không doạ đỏ lúc form còn trống -->
                      <div v-if="showAccountStatus" class="account-status">
                        <span v-if="total == 1" class="text-success">
                          <i class="flaticon2-check-mark icon-sm mr-1" />
                          {{ form.fullNameSearch || 'Đã có tài khoản' }}
                        </span>
                        <span v-else class="text-danger">
                          Số này chưa có tài khoản
                        </span>
                      </div>
                    </b-col>

                    <b-col md="6">
                      <basic-input
                        label="Tên gói"
                        placeholder="Tên"
                        name="name"
                        data-vv-As="Tên gói"
                        :required="true"
                        v-validate="'required'"
                        :value.sync="form.name"
                        :state="validateState('name')"
                        :invalidFeedback="errors.first('name')"
                      ></basic-input>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="6">
                      <basic-select
                        label="Gói dịch vụ"
                        placeholder="--- Chọn gói dịch vụ ---"
                        data-vv-As="Gói dịch vụ"
                        track-by="id"
                        value-label="text"
                        :options="servicePackages"
                        :value.sync="form.selectedservicePackage"
                        name="servicePackage"
                        v-validate="'required'"
                        :state="validateState('servicePackage')"
                        :invalidFeedback="errors.first('servicePackage')"
                        @input="selected($event, 'servicePackage', servicePackages)"
                      />
                    </b-col>

                    <b-col md="6">
                      <basic-select
                        label="Loại nhắc nhở"
                        placeholder="Zalo"
                        name="reminderMethod"
                        data-vv-As="Loại nhắc nhở"
                        :options="reminderMethodOptions"
                        :required="true"
                        v-validate="'required'"
                        :value.sync="reminderMethod"
                        :state="validateState('reminderMethod')"
                        :invalidFeedback="errors.first('reminderMethod')"
                        track-by="value"
                        value-label="text"
                        @input="selected($event, 'reminderMethod', reminderMethodOptions)"
                      ></basic-select>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="6">
                      <basic-date-picker
                        label="Ngày bắt đầu"
                        placeholder="Ngày bắt đầu"
                        name="startDate"
                        data-vv-As="Ngày bắt đầu"
                        :required="true"
                        v-validate="'required'"
                        :value.sync="form.startDate"
                        :state="validateState('startDate')"
                        :invalidFeedback="errors.first('startDate')"
                        format="DD/MM/YYYY"
                        @input="clearValidation('startDate')"
                      />
                    </b-col>

                    <b-col md="6">
                      <basic-date-picker
                        label="Ngày kết thúc"
                        placeholder="Ngày kết thúc"
                        name="endDate"
                        data-vv-As="EndDate"
                        :required="true"
                        v-validate="'required'"
                        :value.sync="form.endDate"
                        :disabled="true"
                        :state="validateState('endDate')"
                        :invalidFeedback="errors.first('endDate')"
                        format="DD/MM/YYYY"
                      />
                    </b-col>
                  </b-row>

                  <!-- Cấp độ ẩn khỏi UI, luôn gửi 1. Người tạo gói không có căn cứ
                       nào để chọn nên đây chỉ là một bước thừa. -->

                  <b-row v-if="isCreateForm">
                    <b-col md="6">
                      <basic-select
                        label="Chế độ nội dung nhắc nhở"
                        placeholder="Nhắc nhở thường"
                        name="contentMode"
                        data-vv-As="Chế độ nội dung nhắc nhở"
                        :options="contentModeOptions"
                        track-by="value"
                        value-label="text"
                        :value.sync="contentMode"
                      />
                    </b-col>
                  </b-row>

                </div>
              </div>
            </b-col>
          </b-row>
          <b-modal
            v-model="showAiReview"
            size="xl"
            scrollable
            hide-header
            hide-footer
            no-close-on-backdrop
            @hidden="finishAfterCreate"
          >
            <reminder-ai-mode-tab
              :user-package-id="createdUserPackageId"
              @close="showAiReview = false"
            />
          </b-modal>

          <b-modal
            id="accept-modal"
            ref="accept-modal"
            title="Xác nhận thông tin"
            size="sd"
            :hide-header-close="true"
            :no-close-on-backdrop="true"
          >
            <b-overlay>
              <p style="text-align: center; font-weight: bold">
                <span v-if="isCreateForm">
                  Bạn có chắc muốn tạo UserPackage mới này không?
                </span>
                <span v-else>
                  Bạn có chắc muốn cập nhật thông tin UserPackage này hay không?
                </span>
              </p>

              <!-- Hai chế độ tạo ra hai hành vi rất khác nhau, nói rõ trước khi xác nhận.
                   AI Mode tô vàng cảnh báo: tạo xong mà bỏ ngang thì gói nằm im, khách
                   không nhận gì — và không có gì báo cho ai biết điều đó. -->
              <div
                v-if="isCreateForm"
                class="confirm-mode mb-4"
                :class="contentModeValue === 1 ? 'confirm-mode--warn' : 'confirm-mode--calm'"
              >
                <div class="confirm-mode__label">Chế độ nội dung nhắc nhở</div>

                <div class="confirm-mode__value">
                  <span v-if="contentModeValue === 1" class="confirm-mode__icon">⚠️</span>
                  {{ contentModeValue === 1 ? 'AI Mode' : 'Nhắc nhở thường' }}
                </div>

                <div class="confirm-mode__desc">
                  <template v-if="contentModeValue === 1">
                    Nhắc nhở <b>chưa được đặt lịch</b>. Tạo xong sẽ mở màn duyệt để AI gợi ý
                    nội dung, coach duyệt xong mới đặt lịch gửi.
                    <b class="confirm-mode__strong">Không duyệt thì khách không nhận được gì.</b>
                  </template>
                  <template v-else>
                    Nhắc nhở được đặt lịch ngay, gửi nguyên nội dung từ chương trình,
                    không cần ai duyệt.
                  </template>
                </div>
              </div>
              <basic-input
                label="Tên khách hàng"
                placeholder="Nhập tên"
                name="fullNameSearch"
                data-vv-As="fullNameSearch"
                :required="false"
                v-validate="'required'"
                :value.sync="form.fullNameSearch"
                :state="validateState('fullNameSearch')"
                :invalidFeedback="errors.first('fullNameSearch')"
              ></basic-input>
              <div class="d-flex align-items-center">
                <basic-input
                  label="Số điện thoại"
                  placeholder="Số điện thoại"
                  name="phoneNumber"
                  :required="true"
                  v-validate="{ required: true, regex: /^[0-9]+$/ }"
                  :value.sync="form.phoneNumber"
                  :state="validateState('phoneNumber')"
                  :invalidFeedback="errors.first('phoneNumber')"
                  @input="getPatientExisted"
                  type="number"
                  maxlength="10"
                  class="mr-2 flex-grow-1"
                ></basic-input>
                <div class="flex-grow-1">
                  <span v-if="this.total == 1" class="text-success">
                    {{
                      this.form.fullNameSearch
                        ? this.form.fullNameSearch
                        : 'Đã có tài khoản'
                    }}
                  </span>
                  <span v-else class="text-danger">
                    {{ 'Chưa có tài khoản' }}
                  </span>
                </div>
              </div>
            </b-overlay>
            <template #modal-footer>
              <div class="w-100 d-flex align-items-center justify-content-end">
                <b-button
                  class="btn btn-plain ml-2"
                  href="#"
                  @click.stop="handleCancel"
                  tabindex="0"
                >
                  Thoát
                </b-button>
                <b-button
                  class="btn btn-success ml-2"
                  href="#"
                  @click.stop="submit"
                  tabindex="0"
                  :disabled="loading"
                >
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
                  </span>
                  Xác nhận
                </b-button>
              </div>
            </template>
          </b-modal>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
import { convertDateToTimestamp } from '@/core/mixins/index.js';
import ReminderAiModeTab from '@/view/pages/reminder_ai/components/ReminderAiModeTab.vue';

// Cấp độ gói: đã bỏ khỏi giao diện vì người tạo không có căn cứ nào để chọn.
const DEFAULT_LEVEL = 1;

// 0 = nhắc nhở thường (luồng cũ), 1 = AI viết lại + coach duyệt.
// Để ngoài data() vì cả giá trị mặc định lẫn resetData đều cần phần tử đầu.
const CONTENT_MODES = [
  { value: 0, text: 'Nhắc nhở thường' },
  { value: 1, text: 'AI Mode' },
];

export default {
  components: {
    ReminderAiModeTab,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
    // Bật khi component được nhúng trong b-modal: bỏ thanh tiêu đề trang,
    // bỏ khung card, và báo ra ngoài thay vì tự điều hướng.
    inModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentModeOptions: CONTENT_MODES,
      contentMode: CONTENT_MODES[0],
      showAiReview: false,
      createdUserPackageId: null,

      servicePackages: [{ id: '1', text: 'Option 1' }],
      selectedservicePackage: 0,
      allReminderMethodOptions: [
        { value: 0, text: 'Thông báo qua nhóm Zalo' },
        { value: 1, text: 'Thông báo qua ứng dụng DIAB' },
        { value: 2, text: 'Đồng thời qua nhóm Zalo và ứng dụng DIAB' },
        { value: 3, text: 'Không gửi thông báo' },
      ],
      form: {
        phoneNumber: null,
        fullNameSearch: null,
        name: null,
        // Ẩn khỏi UI, luôn gửi 1. Màn edit nạp dữ liệu cũ thì giữ nguyên giá trị đó.
        level: DEFAULT_LEVEL,
        selectedservicePackage: null,
        startDate: null,
        endDate: null,
      },
      reminderMethod: null,
      file: null,
      preview: null,
      loading: false,
      accountId: null,
      hasZaloGroup: true,
      // null = chưa tra số nào, khác với 'tra rồi mà không thấy'
      total: null,
      coachesList: [],
      selectedCoach: [],
    };
  },

  async created() {
    await Promise.all([
      this.initDataInSelect(),
      this.loadUserPackageData(),
  //    this.getCoachList(),
    ]);

    // Vào từ "Tiếp tục AI Mode": mở thẳng màn gợi ý. Gợi ý dở dở nằm trên Redis,
    // ReminderAiModeTab tự nạp lại theo userPackageId nên không cần truyền gì thêm.
    if (this.$route.query.ai === '1' && this.$route.params.id) {
      this.createdUserPackageId = this.$route.params.id;
      this.showAiReview = true;
    }
  },
  watch: {
    'form.startDate': function (newVal) {
      if (newVal && this.form.selectedservicePackage) {
        this.getUserPackageEndDate();
      }
    },
    'form.selectedservicePackage': function (newVal) {
      if (newVal && this.form.startDate) {
        this.getUserPackageEndDate();
      }
    },
  },

  computed: {
    // basic-select lúc trả object lúc trả scalar, giống hệt reminderMethod
    contentModeValue() {
      return this.contentMode?.value ?? this.contentMode ?? 0;
    },
    // Chỉ báo tình trạng tài khoản khi đã thực sự tra xong một số
    showAccountStatus() {
      return !!this.form.phoneNumber && this.total !== null;
    },
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
    reminderMethodOptions() {
      if (this.hasZaloGroup) {
        return this.allReminderMethodOptions;
      }
      return this.allReminderMethodOptions.filter((opt) => opt.value === 1 || opt.value === 3);
    },
  },
  methods: {
    async getPatientExisted() {
      // Auto replace +84 -> 84
      if (this.form.phoneNumber) {
        this.form.phoneNumber = this.form.phoneNumber.replace(/^\+/, '');
      }
      this.accountId = null;
      this.form.fullNameSearch = null;
      this.total = null;
      this.gender = null;
      this.hasZaloGroup = true;
      // Không gọi API nếu phone trống
      if (!this.form.phoneNumber) return;
      this.$api
        .get(`UserPackage/by-phone/${this.form.phoneNumber}`)
        .then((response) => {
          if (response.meta.total == 1) {
            this.accountId = response.data.accountId;
            this.form.fullNameSearch = response.data.fullName;
            this.gender = response.data.gender;
            this.hasZaloGroup = !!response.data.hasZaloGroup;
            if (
              !this.hasZaloGroup &&
              this.reminderMethod?.value !== 1 &&
              this.reminderMethod?.value !== 3
            ) {
              this.reminderMethod = this.allReminderMethodOptions.find(
                (opt) => opt.value === 1,
              );
            }
          }
          this.total = response.meta.total;
        });
    },
    clearValidation(fieldName) {
      if (this.form[fieldName]) {
        this.$validator.reset({ name: fieldName });
        this.$validator.errors.remove(fieldName);
        this.$validator.validate(fieldName);
      }
    },
    selected(value, formProperty, optionsArr) {
      if (formProperty === 'servicePackage') {
        this.form[formProperty] =
          optionsArr.find((el) => el.id === value) || null;
      } else {
        this.form[formProperty] =
          optionsArr.find((el) => el.value === value) || null;
      }

      if (this.form[formProperty] || this.form[formProperty]?.value === 0) {
        this.$validator.reset({ name: formProperty });
        this.$validator.errors.remove(formProperty);
        this.$validator.validate(formProperty);
      }
    },
    resetData() {
      this.reminderMethod = null;
      this.form.name = null;
      this.form.level = DEFAULT_LEVEL;
      this.contentMode = CONTENT_MODES[0];
      this.form.selectedservicePackage = null;
      this.form.startDate = null;
      this.form.endDate = null;
      this.accountId = null;
      this.form.phoneNumber = null;
      this.form.fullNameSearch = null;
      this.$validator.reset();
      this.$validator.errors.clear();
    },
    async initDataInSelect() {
      try {
        this.loading = true;
        const [servicePackageList] = await Promise.all([
          this.$api.get(`/servicePackage`, { params: { size: 1000 } }),
        ]);
        this.servicePackages = this.mapDataSelect(servicePackageList);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({ name: 'user_package_list' })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      } else {
        this.$bvModal.show('accept-modal');
      }
    },
    async getUserPackageEndDate() {
      if (!this.form.selectedservicePackage || !this.form.startDate) return;
      try {
        this.loading = true;
        const startDateTimestamp = convertDateToTimestamp(this.form.startDate);
        const { data } = await this.$api.get(
          `UserPackage/ServicePackageId?id=${this.form.selectedservicePackage}&startDate=${startDateTimestamp}`,
        );
        const endDate = new Date(data * 1000); // Nhân 1000 để đổi giây thành mili giây
        this.form.endDate = `${endDate
          .getDate()
          .toString()
          .padStart(2, '0')}/${(endDate.getMonth() + 1)
          .toString()
          .padStart(2, '0')}/${endDate.getFullYear()}`;
        this.clearValidation('endDate');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error.message || 'Không thể lấy ngày kết thúc',
        });
      } finally {
        this.loading = false;
      }
    },
    async handleCancel() {
      this.accountId = null;
      this.form.fullNameSearch = null;
      this.$bvModal.hide('accept-modal');
    },
    async submit() {
      if (
        this.form.phoneNumber == null ||
        this.form.phoneNumber == '' ||
        !/^\d+$/.test(this.form.phoneNumber)
      ) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Số điện thoại không hợp lệ',
        });
        return;
      }
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;

      payload.append('reminderMethod', this.reminderMethod?.value ?? this.reminderMethod ?? '');
      // BE dùng cột này để quyết định: tới giờ gửi mà chưa có bản ghi duyệt thì
      // gói AI Mode huỷ nhắc nhở, gói thường vẫn gửi như cũ.
      payload.append('contentMode', this.contentModeValue);
      this.form.name && payload.append('name', this.form.name);
      this.form.level &&
        payload.append(
          'level',
          typeof this.form.level === 'object'
            ? this.form.level.value
            : this.form.level,
        );
      this.form.startDate &&
        payload.append(
          'startDate',
          convertDateToTimestamp(this.form.startDate),
        );
      this.form.endDate &&
        payload.append('endDate', convertDateToTimestamp(this.form.endDate));
      this.form.phoneNumber &&
        payload.append('phoneNumber', this.form.phoneNumber);
      this.form.fullNameSearch &&
        payload.append('fullName', this.form.fullNameSearch);
      this.accountId && payload.append('accountId', this.accountId);
      this.form.selectedservicePackage &&
        payload.append('servicePackageId', this.form.selectedservicePackage);

      this.gender && payload.append('gender', this.gender);

      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        const res = await this.$api.post(`UserPackage`, payload);

        // Luồng cũ đóng modal xác nhận bằng cách rời trang, nên nó không có lệnh
        // hide nào. AI Mode ở lại trang -> phải tự đóng, không thì nó nằm đè lên
        // màn duyệt và người dùng tưởng bấm Tạo mới không có gì xảy ra.
        this.$bvModal.hide('accept-modal');

        const newId = this.extractUserPackageId(res);
        const isAiMode = this.contentModeValue === 1;

        // AI Mode chưa xong việc ở đây: chưa có gợi ý, chưa duyệt, chưa có job nào.
        // Báo "đã được tạo!" lúc này là nói sai — người dùng đóng modal rồi bỏ đi.
        if (isAiMode && newId) {
          this.createdUserPackageId = newId;
          await this.$nextTick();
          this.showAiReview = true;
          return;
        }

        if (isAiMode && !newId) {
          this.$toastr.e({
            title: 'Không mở được AI Mode',
            msg: 'Gói đã tạo nhưng API không trả về id. Vào lại gói để chạy AI Mode.',
          });
        } else {
          this.$toastr.s({
            title: 'Thành công!',
            msg: 'Chúc mừng, UserPackage mới đã được tạo!',
          });
        }

        this.resetData();
        this.$router.push({ name: 'user_package_list' });
      } catch (e) {
        // Đóng modal xác nhận để người dùng về đúng form đang điền mà sửa (đổi gói dịch
        // vụ, đổi kênh nhắc nhở) — để nó đè lên thì đọc được lỗi mà không chạm được form.
        this.$bvModal.hide('accept-modal');
        // ApiService.post ném `error.data.error` khi có, nhưng lỗi 500 / lỗi không đúng
        // khuôn thì ném nguyên `error.data` hoặc một chuỗi — nên phải dò đủ các dạng.
        // Fallback KHÔNG được đoán là lỗi SĐT: gói sai kênh cũng rơi vào đây và người
        // dùng đi sửa số điện thoại trong khi lỗi nằm ở chỗ khác.
        const raw =
          e?.message ||
          e?.data?.error?.message ||
          e?.data?.message ||
          (typeof e === 'string' ? e : '');

        // Lỗi 500 trả về nguyên trang DeveloperExceptionPage — chuỗi hàng nghìn ký tự kèm
        // stack trace. Đổ vào toast thì vừa vô dụng vừa che hết màn hình, nên chỉ nhận
        // message ngắn gọn một dòng; còn lại dùng câu chung.
        const usable = raw && raw.length <= 300 && !raw.includes('\n') ? raw : '';

        this.$toastr.e({
          title: 'Lỗi!',
          msg:
            usable ||
            'Tạo gói thất bại. Kiểm tra lại thông tin gói dịch vụ, kênh nhắc nhở và số điện thoại.',
        });
      } finally {
        this.loading = false;
      }
    },
    // UserPackageController.Create trả `new DataResult<Guid>(entity.Id)`,
    // tức data là CHUỖI guid chứ không phải object. Các nhánh còn lại để phòng
    // trường hợp endpoint đổi kiểu trả về sau này.
    extractUserPackageId(res) {
      const data = res?.data ?? res;
      if (!data) return null;
      if (typeof data === 'string') return data;
      if (Array.isArray(data)) return data[0]?.id || null;
      if (Array.isArray(data.items)) return data.items[0]?.id || null;
      return data.id || null;
    },

    // Đóng màn duyệt mới quay về danh sách, để coach không bị mất chỗ đang làm
    finishAfterCreate() {
      this.createdUserPackageId = null;
      this.resetData();
      this.$router.push({ name: 'user_package_list' });
    },

    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`UserPackage/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, UserPackage đã được cập nhật!',
        });
        this.$router.push({ name: 'user_package_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadUserPackageData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`UserPackage/${id}`);
        this.form = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async getCoachList() {
      const coachList = await this.$api.get('/Account/ZaloIdCoachs');
      this.coachesList = coachList.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.confirm-mode {
  border: 1px solid #ebedf3;
  border-radius: 6px;
  padding: 0.75rem 1rem;

  &__label {
    font-size: 0.85rem;
    color: #b5b5c3;
  }

  &__value {
    font-weight: 600;
    color: #3f4254;
  }

  &__desc {
    font-size: 0.85rem;
    color: #7e8299;
    margin-top: 0.35rem;
  }

  // Viền trái dày: mắt bắt được khối này trước cả khi đọc chữ. Dùng vàng chứ không
  // dùng đỏ — đây không phải lỗi, chỉ là một việc chưa xong mà người tạo phải làm nốt.
  &--warn {
    border-color: #ffd07b;
    border-left: 4px solid #f0a52a;
    background: #fff8ec;

    .confirm-mode__label { color: #a9772a; }
    .confirm-mode__value { color: #8a5a10; font-size: 1.05rem; }
    .confirm-mode__desc { color: #6b5320; }
  }

  &--calm {
    border-left: 4px solid #1bc5bd;
  }

  &__icon {
    margin-right: 0.25rem;
  }

  &__strong {
    display: block;
    margin-top: 0.25rem;
    color: #a94442;
  }
}

.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
.inline-phone-container {
  display: inline-block;
}
.inline-input {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.inline-name {
  display: inline-block;
  vertical-align: middle;
  color: #333;
  margin-left: 45%;
  margin-top: -58%;
}
</style>
